import { log } from '../app/logger.js';
import { MapLocations } from '../map/map_locations.js';

/**
 * Map working with locations.
 */
function LocMapMixin(mapClass) {
  return class LocMap extends mapClass {
    constructor(...args) {
      super(...args);

      this.locs = new MapLocations(this);
      this.loadInViewPromise = Promise.resolve();

      const eventNames = ['bounds_changed', 'zoom_changed'];
      for (let eventName of eventNames) {
        this.on(eventName, (...args) => this[`on_${eventName}`](...args));
      }
    }

    async panAndZoomTo(loc) {
      // Fit bounds if any or pan to and zoom the location.
      let bounds = await loc.getArea();
      if (this.constructor.isValidBounds(bounds)) {
        return this.fitBounds(bounds);
      }
      let zoom = loc.typeInfo.zoom || this.defaultZoom;
      if (this.zoom > zoom) {
        zoom = undefined;
      }
      this.panTo({
        lat: loc.lat,
        lng: loc.lng,
        zoom,
      });
    }

    on(eventName, listener) {
      switch (eventName) {
        case 'locations_loaded':
        case 'trackactive':
        case 'trackclick':
        case 'trackinactive':
          this.#listeners.push([eventName, listener]);
          return listener;

        default:
          return super.on(eventName, listener);
      }
    }

    off(eventName, listener) {
      switch (eventName) {
        case 'locations_loaded':
        case 'trackactive':
        case 'trackclick':
        case 'trackinactive':
          {
            let idx = this.#listeners.findIndex(
              l => l[0] == eventName && l[1] == listener
            );
            if (idx != -1) {
              this.#listeners.splice(idx, 1);
            }
          }
          break;

        default:
          super.off(eventName, listener);
          break;
      }
    }

    fire(event) {
      this.#listeners.filter(l => l[0] == event.type).forEach(l => l[1](event));
    }

    get activePickControl() {
      return this.#activePickControl;
    }

    set activePickControl(v) {
      this.#activePickControl = v;
    }

    isPickTrackControlActive() {
      return (
        this.#activePickControl &&
        this.#activePickControl.localName == 'pick-track-control'
      );
    }

    on_bounds_changed() {
      if (!mapClass.isValidBounds(this.bounds)) {
        return;
      }

      if (this.getLocationsTimeoutId) {
        clearTimeout(this.getLocationsTimeoutId);
        this.getLocationsTimeoutId = 0;
      }

      this.getLocationsTimeoutId = setTimeout(() => {
        log(`[map] load locations in view`);
        this.loadInViewPromise = this.loadInViewPromise.then(() =>
          this.locs.loadInView()
        );

        let loadInViewPromise = this.loadInViewPromise;
        loadInViewPromise.then(() => {
          if (loadInViewPromise == this.loadInViewPromise) {
            log(`[map] fire locations_loaded event`);
            this.loadInViewPromise = Promise.resolve();
            this.fire({
              type: 'locations_loaded',
            });
          }
        });
      }, 300);
    }

    on_zoom_changed() {
      log('[map] map zoom changed, filter locs');
      setTimeout(() => this.locs.filter(), 300);
    }

    #listeners = [];
    #activePickControl = null;
  };
}

export { LocMapMixin };
